import { render, staticRenderFns } from "./CFeatureCommon.vue?vue&type=template&id=5d6af906&functional=true&"
import script from "./CFeatureCommon.vue?vue&type=script&lang=js&"
export * from "./CFeatureCommon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports